import { render, staticRenderFns } from "./ApneaTestDetails.vue?vue&type=template&id=5de6dd9d"
import script from "./ApneaTestDetails.vue?vue&type=script&lang=js"
export * from "./ApneaTestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports